<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- 页头 -->
							<div class="page_header">Search CAPA Requests</div>
							<div class="page_main">
								<el-form :model="query" label-position="top" class="search-form">
									<div class="form-grid">
										<!-- 左侧 -->
										<div class="form-col">
											<el-form-item label="CAPA ID">
												<el-input v-model="query.id" placeholder="Please enter" clearable />
											</el-form-item>
											<el-form-item label="Source Type">
												<el-select v-model="query.source_type" class="full-width" placeholder="Please select"
													clearable>
													<el-option label="Calibration" value="Calibration" />
													<el-option label="Change Request" value="Change Request" />
													<el-option label="Clinical" value="Clinical" />
													<el-option label="Complaint" value="Complaint" />
													<el-option label="Design Control" value="Design Control" />
													<el-option label="Environmental" value="Environmental" />
													<el-option label="External Audit" value="External Audit" />
													<el-option label="Opportunity for Improvement" value="Opportunity for Improvement" />
													<el-option label="Internal Audit" value="Internal Audit" />
													<el-option label="Issue" value="Issue" />
													<el-option label="Maintenance" value="Maintenance" />
													<el-option label="Management Review" value="Management Review" />
												</el-select>
											</el-form-item>
											<el-form-item label="Source Information">
												<el-input v-model="query.source_info" placeholder="Please enter" clearable />
											</el-form-item>
											<el-form-item label="Description">
												<el-input v-model="query.description" placeholder="Please enter" clearable />
											</el-form-item>
											<!-- <el-form-item label="Affected Company">
												<div class="input-btn-group">
													<el-select v-model="query.company_id" placeholder="Please select" class="full-width" @change="getDepartment(query.company_id)" clearable>
														<el-option v-for="value in companyList" :key="value.id" :label="value.company_name" :value="value.id"></el-option>
													</el-select>
												</div>
											</el-form-item> -->
											<el-form-item label="Affected Department">
												<div class="input-btn-group">
													<el-select v-model="query.departments_id" placeholder="Please select" class="full-width" clearable>
														<el-option v-for="value in departmentsList" :key="value.id" :label="value.departments_name" :value="value.id"></el-option>
													</el-select>
												</div>
											</el-form-item>
											<el-form-item label="Status">
												<el-select v-model="query.status" class="full-width" placeholder="Please select" clearable>
													<el-option label="Open" :value="1" />
													<el-option label="Submitted" :value="2" />
													<el-option label="New Request" :value="3" />
													<el-option label="On Hold" :value="4" />
													<el-option label="Investigation" :value="5" />
													<el-option label="Implementation" :value="6" />
													<el-option label="CAPA Effectiveness Verification" :value="7" />
													<el-option label="Closed" :value="8" />
													<el-option label="Withdrawn" :value="9" />
												</el-select>
											</el-form-item>
											<el-form-item label="Priority">
												<el-select v-model="query.priority" class="full-width" placeholder="Please select" clearable>
													<el-option label="High" :value="1" />
													<el-option label="Medium" :value="2" />
													<el-option label="Low" :value="3" />
												</el-select>
											</el-form-item>
											<el-form-item label="Affected Article ID">
												<el-input v-model="query.article_id" placeholder="Please enter" clearable /></el-form-item>
											<el-form-item label="Affected Product Supplier">
												<el-select v-model="query.supplier_id" class="full-width" placeholder="Please select" clearable>
													<el-option v-for="(value, index) in suplierList" :key="index" :label="value.title" :value="value.id" />
												</el-select>
											</el-form-item>
										</div>
										<!-- 右侧 -->
										<div class="form-col">
											<el-form-item label="Created Date">
												<el-date-picker v-model="time" type="datetimerange" @change="getTime" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<el-form-item label="Request Date">
												<el-date-picker v-model="time1" type="datetimerange" @change="getTime1" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<el-form-item label="Acceptance Date">
												<el-date-picker v-model="time2" type="datetimerange" @change="getTime2" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<el-form-item label="Investigation Start Date">
												<el-date-picker v-model="time3" type="datetimerange" @change="getTime3" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<el-form-item label="Investigation Completion Date">
												<el-date-picker v-model="time4" type="datetimerange" @change="getTime4" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<el-form-item label="Implementation Start Date">
												<el-date-picker v-model="time5" type="datetimerange" @change="getTime5" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<el-form-item label="Implementation Completion Date">
												<el-date-picker v-model="time6" type="datetimerange" @change="getTime6" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<el-form-item label="Closure Date">
												<el-date-picker v-model="time7" type="datetimerange" @change="getTime7" range-separator="To" start-placeholder="Select Start Date" end-placeholder="Select End Date" class="full-width" :default-time="['00:00:00', '23:59:59']">
												</el-date-picker>
											</el-form-item>
											<!-- <el-form-item label="后续是否需要提出 CAPA 请求？">
												<el-select v-model="query.is_request" placeholder="请选择"
													class="full-width" clearable>
													<el-option label="是" :value="1"></el-option>
													<el-option label="否" :value="2"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="CAPA 请求是否需要后续跟进？">
												<el-select v-model="query.is_followup" placeholder="请选择"
													class="full-width" clearable>
													<el-option label="是" :value="1"></el-option>
													<el-option label="否" :value="2"></el-option>
												</el-select>
											</el-form-item> -->
											<el-form-item label="Are There Any Overdue Incomplete Tasks?">
												<el-select v-model="query.is_not_completed" placeholder="Please select"
													class="full-width" clearable>
													<el-option label="Yes" :value="1"></el-option>
													<el-option label="No" :value="2"></el-option>
												</el-select>
											</el-form-item>
										</div>
									</div>
									<el-form-item label="Is There a Supplier-related Root Cause?">
										<el-select v-model="query.is_supplier" class="full-width" placeholder="Please select"
											clearable style="width: 100%">
											<el-option label="Yes" :value="1" />
											<el-option label="No" :value="2" />
										</el-select>
									</el-form-item>
									<div class="search-btn-wrap">
										<el-button type="primary" @click="handleSearch">
											Search
										</el-button>
									</div>
								</el-form>
								<!--表格-->
								<div class="file-panel">
									<div class="panel-header">
										<div></div>
										<el-input v-model="keyword" placeholder="Search" clearable class="search-input">
											<i slot="prefix" class="el-input__icon el-icon-search"></i>
										</el-input>
									</div>
									<el-table v-loading="tableloading" :data="trainTableData" border class="file-table"
										header-cell-class-name="table-header-cell" empty-text="No Data">
										<el-table-column prop="request_id" label="CAPA ID" width="180" sortable
											show-overflow-tooltip />
										<el-table-column prop="description" label="Description" width="200" sortable
											show-overflow-tooltip />
										<el-table-column prop="" label="Status" width="120" sortable align="">
											<template slot-scope="scope">
												<div v-if="scope.row.status == 1">Open</div>
												<div v-if="scope.row.status == 2">Submitted</div>
												<div v-if="scope.row.status == 3">New Request</div>
												<div v-if="scope.row.status == 4">On Hold</div>
												<div v-if="scope.row.status == 5">Investigation</div>
												<div v-if="scope.row.status == 6">Implementation</div>
												<div v-if="scope.row.status == 7">CAPA Effectiveness Verification</div>
												<div v-if="scope.row.status == 8">Closed</div>
												<div v-if="scope.row.status == 9">Withdrawn</div>
											</template>
										</el-table-column>
										<el-table-column prop="" label="Priority" width="120" sortable
											show-overflow-tooltip>
											<template slot-scope="scope">
											    <div v-if="scope.row.priority == 1">High</div>
												<div v-if="scope.row.priority == 2">Medium</div>
												<div v-if="scope.row.priority == 3">Low</div>
												<div v-if="!scope.row.priority">/</div>
											</template>
										</el-table-column>

										<!-- <el-table-column prop="" label="Affected Company" width="180" sortable align="">
											<template slot-scope="scope">
												{{ scope.row.company_name || "/" }}
											</template>
										</el-table-column> -->
										<el-table-column prop="" label="Affected Department" width="200" sortable align="">
											<template slot-scope="scope">
												{{ scope.row.departments_name || "/" }}
											</template>
										</el-table-column>
										<el-table-column prop="" label="Source Type" sortable align="center">
											<template slot-scope="scope">
												{{ scope.row.source_type || "/" }}
											</template>
										</el-table-column>
										<el-table-column prop="" label="Source Information" width="180" sortable align="center">
											<template slot-scope="scope">
												{{ scope.row.source_info || "/" }}
											</template>
										</el-table-column>
										<el-table-column label="Actions" width="120" fixed="right" align="center">
											<template slot-scope="scope">
												<el-link type="primary" size="mini" @click="handleInfo(scope.row)">
													Details
												</el-link>
											</template>
										</el-table-column>
									</el-table>
									<div class="pagination">
										<el-pagination @size-change="handleSizeChange"
											@current-change="handlePageChange" :current-page="query.page"
											:page-sizes="[5, 10, 20, 50]" :page-size="query.page_size"
											layout="total, sizes, prev, pager, next" :total="pageTotal">
										</el-pagination>
									</div>
								</div>
								<!--表格-->
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!-- loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
	</div>
</template>

<script>
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
// import { companyList } from "@/api/system/company";
import { departmentsList } from "@/api/system/department";
import { suplierList } from '@/api/capaManage/configCapa/capaManageSuppliers/index';
import { capaSearch } from '@/api/capaManage/capaSearch/index'
import moment from "moment";
moment.locale("zh-cn");
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			tableloading: true,
			keyword: "",
			query: {
				id: "",
				source_type: "",
				source_info: "",
				description: "",
				// company_id: "",
				departments_id: "",
				status: "",
				priority: "",
				article_id: "",
				supplier_id: "",
				time1: "",
				time11: "",
				time2: "",
				time22: "",
				time3: "",
				time33: "",
				time4: "",
				time44: "",
				time5: "",
				time55: "",
				time6: "",
				time66: "",
				time7: "",
				time77: "",
				time8: "",
				time88: "",
				is_not_completed:'',
				is_supplier:"",
				page: 1,
				page_size: 10
			},
			time: "",
			time1: "",
			time2: "",
			time3: "",
			time4: "",
			time5: "",
			time6: "",
			time7: "",
			tableData: [],
			// companyList: [],
			departmentsList: [],
			pageTotal: 0,
			suplierList: []
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getTableData();
		//请求公司列表
		// companyList({
		// 	page: 1,
		// 	page_size: 9999,
		// 	status: 1,
		// 	company_name: "",
		// 	company_userid: "",
		// 	manage_userid: "",
		// }).then((res2) => {
		// 	if (res2.code == 200) {
		// 		that.companyList = res2.data.data;
		// 	}
		// });
		//请求部门列表
		that.getDepartment();
		suplierList({ title: '', description: "", page: 1, page_size: 9999 }).then(res => {
			if(res.code == 200) {
				that.suplierList = res.data;
			}
		});
	},
	computed: {
		trainTableData() {
			return this.filterTableData(this.tableData, this.keyword);
		},
	},
	methods: {
		//时间戳转换
		initTime(value) {
			if (value) {
				return moment(value * 1000).format("YYYY-MM-DD");
			}
		},
		filterTableData(source, keyword) {
			if (!keyword || !keyword.trim()) return source;
			const lowerKeyword = keyword.toLowerCase().trim();
			return source.filter((item) => {
				const text = this.flattenValues(item).toLowerCase();
				return text.includes(lowerKeyword);
			});
		},
		flattenValues(data) {
			if (data === null || data === undefined) return "";
			if (Array.isArray(data)) {
				return data.map((item) => this.flattenValues(item)).join(" ");
			}
			if (typeof data === "object") {
				return Object.values(data)
					.map((val) => this.flattenValues(val))
					.join(" ");
			}
			return String(data);
		},
		//请求部门列表
		getDepartment(val) {
			let that = this;
			that.query.departments_id = "";
			that.departmentsList = [];
			that.$toast.loading({
				duration: 0,
				forbidClick: true
			});
			departmentsList({
				page: 1,
				page_size: 9999,
				status: 1,
				departments_name: "",
				// company_id: value,
				departments_userid: "",
			}).then((res2) => {
				that.$toast.clear();
				that.departmentsList = res2.data.data;
				if (val) {
					that.query.departments_id = Number(val);
				}
			});
		},
		//时间格式化
		dateFormat: function(row, column) {
			let that = this;
			var date = row[column.property];
			if (date == undefined || date == 0) {
				return "/";
			}
			return moment(date * 1000).format("YYYY-MM-DD");
		},
		//创建日期
		getTime(date) {
			let that = this;
			if (date) {
				that.query.time1 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
				that.query.time11 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
			} else {
				that.query.time1 = "";
				that.query.time11 = "";
			}
		},
		//请求日期
		getTime1(date) {
			let that = this;
			if (date) {
				that.query.time2 = moment(date[0]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
				that.query.time2 = moment(date[1]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
			} else {
				that.query.time2 = "";
				that.query.time22 = "";
			}
		},
		//接受日期
		getTime2(date) {
			let that = this;
			if (date) {
				that.query.time3 = moment(date[0]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
				that.query.time33 = moment(date[1]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
			} else {
				that.query.time3 = "";
				that.query.time33 = "";
			}
		},
		//调查开始日期
		getTime3(date) {
			let that = this;
			if (date) {
				that.query.time4 = moment(date[0]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
				that.query.time44 = moment(date[1]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
			} else {
				that.query.time4 = "";
				that.query.time44 = "";
			}
		},
		//调查完成日期
		getTime4(date) {
			let that = this;
			if (date) {
				that.query.time5 = moment(date[0]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
				that.query.time55 = moment(date[1]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
			} else {
				that.query.time5 = "";
				that.query.time55 = "";
			}
		},
		//实施开始日期
		getTime5(date) {
			let that = this;
			if (date) {
				that.query.time6 = moment(date[0]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
				that.query.time66 = moment(date[1]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
			} else {
				that.query.time6 = "";
				that.query.time66 = "";
			}
		},
		//实施完成日期
		getTime6(date) {
			let that = this;
			if (date) {
				that.query.time7 = moment(date[0]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
				that.query.time77 = moment(date[1]).format(
					"YYYY-MM-DD HH:mm:ss"
				);
			} else {
				that.query.time7 = "";
				that.query.time77 = "";
			}
		},
		//关闭日期
		getTime7(date) {
			let that = this;
			if (date) {
				that.query.time8 = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
				that.query.time88 = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
			} else {
				that.query.time8 = "";
				that.query.time88 = "";
			}
		},
		getTableData() {
			let that = this;
			capaSearch(that.query).then((res =>{
             if(res.code == 200){
               that.tableloading = false;
				that.tableData = res.data.data;
				that.pageTotal = res.data.total;
			 }
		}));
		},
		handleSearch() {
			let that = this;
			that.query.page = 1;
			that.getTableData();
		},
		//清空搜索项
		clearSearch() {
			let that = this;
			that.query = {
				id: "",
				source_type: "",
				source_info: "",
				description: "",
				// company_id: "",
				departments_id: "",
				status: "",
				priority: "",
				article_id: "",
				supplier_id: "",
				time1: "",
				time11: "",
				time2: "",
				time22: "",
				time3: "",
				time33: "",
				time4: "",
				time44: "",
				time5: "",
				time55: "",
				time6: "",
				time66: "",
				time7: "",
				time77: "",
				time8: "",
				time88: "",
				is_not_completed:'',
				is_supplier:"",
				page: 1,
				page_size: 10
			};
			that.time = null;
			that.time1 = null;
			that.time2 = null;
			that.time3 = null;
			that.time4 = null;
			that.time5 = null;
			that.time6 = null;
			that.time7 = null;
			that.getTableData();
		},
		//条数选择
		handleSizeChange(value) {
			let that = this;
			that.query.page_size = value;
			that.getTableData();
		},
		//页数跳转
		handlePageChange(value) {
			let that = this;
			that.query.page = value;
			that.getTableData();
		},
		handleInfo(value) {
			let that = this;
			const routeData = that.$router.resolve({
				path: "/CapaControl/searchDeatil",
				query: {
					oid: value.id
				},
			});
			window.open(routeData.href, "_blank");
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 24px;
		align-items: start;
	}

	.form-grid .el-form-item {
		margin-bottom: 0;
	}

	.full-width {
		width: 100%;
	}

	.input-btn-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.input-btn-group .el-input {
		flex: 1;
	}

	.search-btn-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 20px 0 16px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.pagination {
		margin: 10px 0;
		text-align: right;
	}

	::v-deep .el-form-item__label {
		font-size: 16px;
		color: #222;
		font-weight: 700;
		padding-bottom: 8px;
		position: relative;
	}

	::v-deep .el-input__inner,
	::v-deep .el-textarea__inner {
		border-radius: 4px;
	}

	@media (max-width: 1200px) {
		.form-grid {
			grid-template-columns: 1fr;
		}
	}

	::v-deep .el-button {
		border-radius: 6px;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}

	::v-deep .form-grid .el-form-item__label {
		padding-bottom: 0;
	}
</style>